/**
 * @file 延迟执行
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/delay
 */
const next = typeof window !== 'undefined' && (window.setImmediate || window.requestAnimationFrame) || setTimeout;

/**
  * 延迟执行函数
  *
  * @function delay
  * @param {Function} fn 要延迟执行的函数
  * @return {Function} 返回一个包装过的延迟执行的函数
  */
export default fn => (...args) => next(() => fn(...args));
